import React, { createContext, useContext, ReactNode, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ROUTES, MULTI_PLATFORM_MEDIUM_TYPES } from "../constants";
import { getParentUrlQuery } from "../utils/urlUtils";

interface IndependentBotContextValue {
  isSmsMediumActive: boolean;
  isWebMediumActive: boolean;
  isWhatsappMediumActive: boolean;
  multiMediumType: string;
  setMultiMediumType: (type: string) => void;
  forceInputDisable: boolean;
  queryParams: any;
}

const IndependentBotContext = createContext<
  IndependentBotContextValue | undefined
>(undefined);

interface IndependentBotProviderProps {
  children: ReactNode;
}

export const IndependentBotProvider: React.FC<IndependentBotProviderProps> = ({
  children,
}) => {
  const location = useLocation();
  const {
    bot_id: parentBotId,
    conv_id: parentConvId,
    message_id: parentMessageId,
  } = useParams();
  const [multiMediumType, setMultiMediumType] = useState<string>(
    MULTI_PLATFORM_MEDIUM_TYPES.initial
  );
  const queryParams = getParentUrlQuery(window.location.href);
  const isSmsMediumActive =
    location?.pathname?.includes(`/${ROUTES.sms}`) &&
    Boolean(parentBotId) &&
    Boolean(parentConvId);

  const isWhatsappMediumActive =
    location?.pathname?.includes(`/${ROUTES.whatsapp}`) &&
    Boolean(parentBotId) &&
    Boolean(parentConvId);
  const isWebMediumActive =
    location?.pathname?.includes(`/${ROUTES.web}`) && Boolean(parentBotId);
  const forceInputDisable = Boolean(parentMessageId);
  return (
    <IndependentBotContext.Provider
      value={{
        isSmsMediumActive,
        isWebMediumActive,
        multiMediumType,
        setMultiMediumType,
        forceInputDisable,
        isWhatsappMediumActive,
        queryParams,
      }}
    >
      {children}
    </IndependentBotContext.Provider>
  );
};

export const useIndependentBot = (): IndependentBotContextValue => {
  const context = useContext(IndependentBotContext);
  if (!context) {
    throw new Error(
      "useIndependentBot must be used within a IndependentBotProvider"
    );
  }
  return context;
};
